import { render, staticRenderFns } from "./PlanMejoramiento.vue?vue&type=template&id=2b64b754"
import script from "./PlanMejoramiento.vue?vue&type=script&lang=js"
export * from "./PlanMejoramiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports